module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"restart":"Restart"},"es":{"restart":"Reanudar"},"sw":{"restart":"Anzisha tena"}}')
  delete Component.options._Ctor
}
